import React from "react"
import { FaFacebook, FaInstagram } from "react-icons/fa"

const Footer = () => {
  return (
    <footer className="bg-dark-dark text-white pt-12 w-full overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-4 pb-0">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="flex flex-col items-center md:items-start mb-8 md:mb-0">
            <h3 className="text-lg font-bold mb-3">BT Auto Care</h3>
            <p className="text-dark-light text-sm mb-1">
              1621 McEwen Drive
              <br />
              Whitby, Ontario, L1N 9A5, Unit 13
            </p>
            <p className="text-dark-light text-sm mb-1">
              Phone:{" "}
              <a
                href="tel:+19054355751"
                className="no-underline text-red-main hover:text-white"
              >
                (905) 435-5751
              </a>
            </p>
            <p className="text-dark-light text-sm mb-3">
              Email:{" "}
              <a
                href="mailto:btautocaree@gmail.com"
                className="no-underline text-red-main hover:text-white"
              >
                btautocaree@gmail.com
              </a>
            </p>

            <div className="flex space-x-6 mt-2">
              <a
                href="https://www.facebook.com/people/BT-AUTO-CARE/100091770272019/"
                className="text-2xl text-red-main hover:text-white"
                aria-label="BT Auto Care on Facebook"
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://instagram.com/btautocare"
                className="text-2xl text-red-main hover:text-white"
                aria-label="BT Auto Care on Instagram"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <FaInstagram />
              </a>
              {/* <a
                href="https://tiktok.com/@btautocare"
                className="text-2xl text-red-main hover:text-white"
                aria-label="BT Auto Care on TikTok"
                target="_blank"
                rel="noopener noreferrer"
                title="TikTok"
              >
                <FaTiktok />
              </a> */}
            </div>
          </div>

          <nav className="mt-8 lg:mt-0" aria-label="Footer">
            <ul className="flex justify-center lg:justify-end flex-wrap gap-4">
              <li>
                <a
                  href="/"
                  className="text-dark-light font-semibold hover:text-white no-underline"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about/"
                  className="text-dark-light font-semibold hover:text-white no-underline"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/services/"
                  className="text-dark-light font-semibold hover:text-white no-underline"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/blog/"
                  className="text-dark-light font-semibold hover:text-white no-underline"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="/gallery/"
                  className="text-dark-light font-semibold hover:text-white no-underline"
                >
                  Gallery
                </a>
              </li>
              <li>
                <a
                  href="/contact/"
                  className="text-dark-light font-semibold hover:text-white no-underline"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div
        className="text-center text-dark-light text-sm mt-10 pb-4"
        suppressHydrationWarning
      >
        © {new Date().getFullYear()} BT Auto Care. All rights reserved. <br />
        <a
          href="https://nivis.ca"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.4em",
            color: "inherit",
            textDecoration: "none",
          }}
        >
          <img
            src="/images/nivis-icon.png"
            alt=""
            aria-hidden="true"
            style={{ height: "1em", width: "auto", margin: 0 }}
          />
          Built by Nivis
        </a>
      </div>
    </footer>
  )
}

export default Footer
